var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "form",
      {
        on: {
          submit: function ($event) {
            $event.preventDefault()
            return _vm.submit.apply(null, arguments)
          },
        },
      },
      [
        _vm.form.error
          ? _c("div", { staticClass: "alert alert-danger" }, [
              _vm._v(
                "\n            " +
                  _vm._s(
                    _vm.trans("booking-process.find-booking.cannot_find")
                  ) +
                  "\n        "
              ),
            ])
          : _vm._e(),
        _vm._v(" "),
        _c("validated-input", {
          attrs: {
            "label-text": _vm.trans("post_hire.booking_reference_label"),
            name: "bookingReference",
            type: "text",
            placeholder: _vm.trans("post_hire.booking_reference_label"),
            rules: "required",
            "form-type": "vertical",
            columns: 12,
            "formatted-name": _vm.trans("post_hire.booking_reference_label"),
          },
          model: {
            value: _vm.form.bookingReference,
            callback: function ($$v) {
              _vm.$set(_vm.form, "bookingReference", $$v)
            },
            expression: "form.bookingReference",
          },
        }),
        _vm._v(" "),
        _c("validated-input", {
          attrs: {
            "label-text": _vm.trans(
              "booking-process.payment.last_name_placeholder"
            ),
            name: "lastName",
            type: "text",
            placeholder: _vm.trans(
              "booking-process.payment.last_name_placeholder"
            ),
            rules: "required",
            "form-type": "vertical",
            columns: 12,
            "formatted-name": _vm.trans(
              "booking-process.payment.last_name_label"
            ),
          },
          model: {
            value: _vm.form.lastName,
            callback: function ($$v) {
              _vm.$set(_vm.form, "lastName", $$v)
            },
            expression: "form.lastName",
          },
        }),
        _vm._v(" "),
        _c(
          "gm-button",
          {
            staticClass: "regular-button",
            attrs: {
              type: "next",
              busy: _vm.form.busy,
              disabled: _vm.form.disabled,
            },
            on: { click: _vm.submit },
          },
          [
            _vm._v(
              _vm._s(_vm.trans("booking-process.search_additional.search")) +
                " "
            ),
          ]
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }